export type RentalState = 'STARTED' | 'SOLD' | 'STOPPED';

// Rent an asset to a RIO account
export type AccountRental = {
    id: string;
    type: RentalType;
    state: RentalState;
    rentalCompanyAssetId: string;
    rentalCompanyAccountId: string;
    renterAssetId: string;
    renterAccountId: string;
    startedAt: string;
};

// Rent an asset to an external company identified by its name
export type ExternalRental = {
    id: string;
    type: RentalType;
    state: RentalState;
    rentalCompanyAssetId: string;
    rentalCompanyAccountId: string;
    renterIdentifier: string;
    startedAt: string;
};

export type Rental = AccountRental | ExternalRental;

export const RENTAL_TYPE = {
    ACCOUNT: 'ACCOUNT',
    EXTERNAL: 'EXTERNAL',
} as const;

export type RentalType = (typeof RENTAL_TYPE)[keyof typeof RENTAL_TYPE];
